export default {
  EST_SFX: 'sfx',
  EST_FLAG: 'sound_flag',
  EST_EXPLOSION: 'explosion',
  EST_CLICK: 'click',
  EST_BONUS: 'bonus',
}
